import { DeviceConnectedPayload, DeviceDisconnectedPayload, devicesEntity, SensorDataPayload } from '@entities/devices';
import { createEffect, sample } from 'effector';

import { bluetoothEntity, BtScanResultPayload } from '../../../../entities/bluetooth/model';
import { wsClient } from '../../../../shared/configs/socket-client';
import { getDevices } from '../api';
import { bluetoothConnectModel } from '@features/bluetooth/connect-device/model';

const onScanResult = wsClient.on<BtScanResultPayload>('bt_scan_result');
const onDeviceConnectedRaw = wsClient.on<DeviceConnectedPayload>('device_connected');
const onSensorDataUpdatedRaw = wsClient.on<SensorDataPayload>('sensor_update');
const onDeviceDisconnectedRaw = wsClient.on<DeviceDisconnectedPayload>('device_disconnected');
const onBluetoothDisconnectedRaw = wsClient.on('bt_disconnected');

const fetchDevicesFx = createEffect(getDevices);

sample({
  clock: onScanResult,
  fn: (value) => value.data,
  target: bluetoothEntity.setDevices,
});

sample({
  clock: onDeviceConnectedRaw,
  fn: ({ data }) => data,
  target: devicesEntity.onDeviceConnected,
});

const onSensorDataUpdatedFiltered = sample({
  clock: onSensorDataUpdatedRaw,
  filter: ({ data }) => Boolean(data.value),
  fn: ({ data }) => data,
});

sample({
  clock: onSensorDataUpdatedFiltered,
  target: devicesEntity.onSensorDataUpdated,
});

sample({
  clock: onDeviceDisconnectedRaw,
  fn: ({ data }) => data,
  target: devicesEntity.onDeviceDisconnected,
});

sample({
  clock: onBluetoothDisconnectedRaw,
  target: devicesEntity.onBluetoothDisconnected,
});

sample({
  clock: fetchDevicesFx.doneData,
  filter: (devices) => devices.usb.length > 0,
  fn: (devices) => ({
    deviceId: 1,
    deviceName: devices.usb[0],
  }),
  target: devicesEntity.onDeviceConnected,
});

const connectToDeviceFx = createEffect(
  ({ address, name }: { address: string; name: string }) => {
    wsClient.emit({
      action: 'connect_bluetooth',
      data: {
        address,
        name,
      },
    });
  },
);

sample({
  clock: bluetoothConnectModel.connectToDevice,
  target: connectToDeviceFx,
});

const disconnectFromDeviceFx = createEffect((address: string) => {
  wsClient.emit({
    action: 'disconnect_bluetooth',
    data: {
      address,
    },
  });
});

const emitSetFrequencyFx = createEffect((frequency: number) => {
  wsClient.emit({
    action: "set_frequency",
    data: frequency
  })
})

sample({
  clock: devicesEntity.$frequency,
  target: emitSetFrequencyFx
})

sample({
  clock: bluetoothConnectModel.disconnectFromDevice,
  target: disconnectFromDeviceFx,
});
